import { IRootState } from '../../../app/store';

export const selectEnrolledSkills = (state: IRootState) =>
    state.selfEnrollment.enrolledSkills;
export const selectEnrolledSkillsAsyncStatus = (state: IRootState) =>
    state.selfEnrollment.enrolledSkillsAsyncStatus;
export const selectEnrolledSkillAsyncStatus = (state: IRootState) =>
    state.selfEnrollment.enrolledSkillAsyncStatus;
export const selectCreateSelfEnrollmentAsyncStatus = (state: IRootState) =>
    state.selfEnrollment.createSelfEnrollmentAsyncStatus;
export const selectCancelSelfEnrollmentAsyncStatus = (state: IRootState) =>
    state.selfEnrollment.cancelSelfEnrollmentAsyncStatus;
export const selectCurrentEnrolledSkillId = (state: IRootState) =>
    state.selfEnrollment.currentEnrolledSkillId;
export const selectEventSelfEnrolledCourseId = (state: IRootState) =>
    state.selfEnrollment.eventSelfEnrolledCourseId;
